module.exports = __webpack_public_path__ + "static/media/3.15dd4b98.webm";